import R from "ramda";
import { BOOTSTRAP_CURRENCIES } from "actions/bootstrap-actions";

export const initialState = {
  currencies: []
};

export const currenciesReducer = (state = initialState, action) => {
  switch (action.type) {
    case BOOTSTRAP_CURRENCIES:
      return R.merge(state, { currencies: action.data.currencies });
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/js/reducers/currencies-reducer.js